// extracted by mini-css-extract-plugin
export default {"container":"FileDescriptionDiv_container__epUI7","title":"FileDescriptionDiv_title__d80X4","value":"FileDescriptionDiv_value__Nu1az"};